/* LH — Nedtælling. Kører alle instanser på siden. */
(function () {
  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function init(root) {
    if (!root || root.dataset.lhCdReady === '1') return;
    var timer = root.querySelector('[data-lh-cd-timer]');
    if (!timer) return;
    root.dataset.lhCdReady = '1';

    var end = parseInt(timer.getAttribute('data-end'), 10);
    var start = parseInt(timer.getAttribute('data-start'), 10) || 0;
    var expiry = timer.getAttribute('data-expiry');
    var urgentMs = parseInt(timer.getAttribute('data-urgent'), 10) || 0;
    var showDays = timer.getAttribute('data-show-days') === 'true';
    var designMode = !!(window.Shopify && window.Shopify.designMode);
    var endedEl = root.querySelector('[data-lh-cd-ended]');
    var progressEl = root.querySelector('[data-lh-cd-progress]');
    var storageKey = 'lh-cd-' + root.id + '-' + end;
    var handle = null;

    var cells = {};
    var last = {};
    var unitEls = timer.querySelectorAll('[data-unit]');
    for (var i = 0; i < unitEls.length; i++) {
      cells[unitEls[i].getAttribute('data-unit')] = unitEls[i].querySelector('[data-num]');
    }

    function put(key, value) {
      var el = cells[key];
      if (!el) return;
      var text = pad(value);
      if (last[key] === text) return;
      last[key] = text;
      el.textContent = text;
      el.classList.remove('is-tick');
      void el.offsetWidth;
      el.classList.add('is-tick');
    }

    function finish() {
      if (designMode) return;
      if (expiry === 'hide') {
        root.classList.add('is-hidden');
      } else if (expiry === 'message') {
        root.classList.add('is-done');
        if (endedEl) endedEl.hidden = false;
      }
      root.classList.remove('is-urgent');
    }

    function tick() {
      var left = end - Date.now();

      if (left <= 0) {
        for (var k in cells) { if (cells[k]) cells[k].textContent = '00'; }
        if (progressEl) progressEl.style.width = '0%';
        timer.setAttribute('aria-label', 'Tilbuddet er udløbet');
        finish();
        if (handle) clearInterval(handle);
        return;
      }

      var totalSeconds = Math.floor(left / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      if (!showDays) { hours += days * 24; days = 0; }

      put('days', days);
      put('hours', hours);
      put('minutes', minutes);
      put('seconds', seconds);

      timer.setAttribute(
        'aria-label',
        'Tilbage: ' + (showDays ? days + ' dage, ' : '') + hours + ' timer og ' + minutes + ' minutter'
      );

      if (progressEl && start > 0 && end > start) {
        progressEl.style.width = Math.max(0, Math.min(100, (left / (end - start)) * 100)) + '%';
      }

      if (urgentMs > 0 && left <= urgentMs) {
        root.classList.add('is-urgent');
      } else {
        root.classList.remove('is-urgent');
      }
    }

    if (root.getAttribute('data-dismissible') === 'true') {
      var closeBtn = root.querySelector('[data-lh-cd-close]');
      try {
        if (!designMode && window.localStorage.getItem(storageKey) === '1') {
          root.classList.add('is-hidden');
        }
      } catch (e) {}
      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          root.classList.add('is-hidden');
          try { window.localStorage.setItem(storageKey, '1'); } catch (e) {}
        });
      }
    }

    // Tilbudsvarer med flere varianter: gaten og rabatprocenten skal følge
    // den variant kunden faktisk har valgt.
    var mapRaw = root.getAttribute('data-variants');
    if (mapRaw) {
      var vmap = null;
      try { vmap = JSON.parse(mapRaw); } catch (e) {}
      if (vmap) {
        var gate = root.getAttribute('data-only-on-sale') === 'true';
        var badge = root.querySelector('[data-lh-cd-save]');
        var idInput = document.querySelector('form[action*="/cart/add"] [name="id"]');

        var applyVariant = function () {
          if (!idInput) return;
          var info = vmap[idInput.value];
          if (!info) return;
          if (gate && !info.s) {
            root.classList.add('is-hidden');
          } else {
            root.classList.remove('is-hidden');
          }
          if (badge) {
            if (info.s && info.p > 0) {
              badge.textContent = badge.getAttribute('data-prefix') + ' ' + info.p + '%';
              badge.hidden = false;
            } else {
              badge.hidden = true;
            }
          }
        };

        applyVariant();

        // Temaets variantvælger er bygget af <button>-elementer, ikke af
        // formularfelter, så der kommer ingen change-event. Vi holder derfor
        // øje med selve id-feltet. En strengsammenligning hvert 300 ms koster
        // ingenting og fanger enhver måde temaet kan skifte variant på.
        if (idInput) {
          var lastId = idInput.value;
          setInterval(function () {
            if (idInput.value !== lastId) {
              lastId = idInput.value;
              applyVariant();
            }
          }, 300);
          idInput.addEventListener('change', applyVariant);
        }
        document.addEventListener('change', function () { setTimeout(applyVariant, 60); }, true);
        document.addEventListener('variant:change', function () { setTimeout(applyVariant, 60); });
        document.addEventListener('variantChange', function () { setTimeout(applyVariant, 60); });
      }
    }

    tick();
    handle = setInterval(tick, 1000);

    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) tick();
    });
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-lh-cd-root]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
